"use client";

import React from "react";
import PrimaryPromotionHeroBanner from "./PrimaryPromotionHeroBanner";

interface CommonHeroProps {
  badgeText?: string;
  title?: string;
  align?: "left" | "center" | "right";
  backgroundImage?: string;
  bannerTitle?: string;
  bannerDescription?: string;
  bannerButtonLabel?: string;
  height?: string;
  buttonLink?: string;
}

const CommonHero: React.FC<CommonHeroProps> = ({
  badgeText,
  title,
  bannerTitle,
  bannerDescription,
  bannerButtonLabel,
  buttonLink,
}) => {
  return (
    <section
      className="relative w-full  flex items-center justify-center h-[65vh] xl:h-[85vh] 2xl:h-[65vh] section-bg-white-soft rounded-b-[64px] overflow-hidden border-b-12 border-[#ccc]/24"
      style={{
        backgroundImage: "url('/HeroSectionImg/HeroImage-InnerPages.png')",
        backgroundSize: "contain",
        backgroundPosition: "center",
      }}
    >
      <div>
        {/* overlay-badge */}
        <div className="flex items-center justify-center top-5 relative z-100">
          {(badgeText || title) && (
            <div className="relative z-100 text-left">
              {badgeText && (
                <span className="inline-block ml-12  px-3 py-1 text-xs font-semibold text-white bg-red-500 rounded-md">
                  {badgeText}
                </span>
              )}

              {title && (
                <div className="text-xl text-center md:text-xl text-primary bg-white -skew-x-24 px-12 py-3 font-semibold tracking-tight">
                  <span className="inline-block skew-x-24">{title}</span>
                </div>
              )}
            </div>
          )}
        </div>


        {/* Banner Overlay (Clean & Centered) */}
        {bannerTitle && bannerDescription && bannerButtonLabel && (
          <div className="  ">


            <PrimaryPromotionHeroBanner
              title={bannerTitle}
              description={bannerDescription}
              buttonLabel={bannerButtonLabel}
              {...(buttonLink && { buttonLink })}
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default CommonHero;
